module.exports = __webpack_public_path__ + "img/6.085d54de.jpg";